var lib_core = require("lib-core");

var DragDropStateMachine = function (root, model, uploadSM, editorView) {
    var self = this;

    this.model = model;
    this.root = root;
    this.uploadSM = uploadSM;

    lib_core.StateMachine.call(self);

    // bind the drop event onto the editor canvas to grab the file, load it,
    // then send out an event when loading is complete
    editorView.getTemplate().getCanvasEl().bind('drop', function(e) {
        e.stopPropagation();
        e.preventDefault();

        self.handleDraggingFileToEditorCanvas(e);
    });
};

lib_core.inherit(DragDropStateMachine, lib_core.StateMachine);
module.exports = DragDropStateMachine;

DragDropStateMachine.prototype.handleDraggingFileToEditorCanvas = function(e) {
    console.assert(this.uploadSM, "Upload state machine not found.");
    console.log("file dropped"); // TODO turn this into real display message
    
    var files = e.originalEvent.dataTransfer.files; // Array of all files 
    var firstFile = files[0];
    var fileExtension = firstFile.name.split('.').pop().toLowerCase();

    if(this.uploadSM && this.uploadSM.getFileTypes().indexOf(fileExtension) != -1 ) {
        this.uploadSM.consumeFile(firstFile, null, true);
    }
};



